import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';

/**
 * `@[comment:<commentId>]` pills. The moniker names the comment and nothing else, so the card
 * loads `Discussions.Comments.get`. A metadata comment pill already carries its body and is not in
 * this set.
 */
const commentMonikerPills = new WeakSet<WorkspaceAgentMessagePill>();

export const markWorkspaceAgentCommentMonikerPill = (pill: WorkspaceAgentMessagePill): void => {
  commentMonikerPills.add(pill);
};

export const isWorkspaceAgentCommentMonikerPill = (pill: WorkspaceAgentMessagePill): boolean =>
  commentMonikerPills.has(pill);
